const sockets = {
  CHAT_MESSAGE: 'CHAT_MESSAGE',
  CHAT_MESSAGE_READ: 'CHAT_MESSAGE_READ',
  NOTIFICATION: 'NOTIFICATION',
}

export default sockets
